import { render, staticRenderFns } from "./ThemeTab.vue?vue&type=template&id=9f0b9712&scoped=true"
import script from "./ThemeTab.vue?vue&type=script&lang=js"
export * from "./ThemeTab.vue?vue&type=script&lang=js"
import style0 from "./ThemeTab.vue?vue&type=style&index=0&id=9f0b9712&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0b9712",
  null
  
)

export default component.exports